import { IPerson } from "@/services/DTOs/Person";
import { ISnowplowContext } from "./SnowplowContext";

export interface IUserContextSchema {
  schema: string;
  data: IUserSnowplowContextData;
}

export interface IUserSnowplowContextData {
  type: string;
  subjectId?: number;
  name: string;
  email?: string;
  publicId?: string;
  hasPicture: boolean;
  hasBio: boolean;
  bioCompletion: number;
  locale?: string;
  created?: string;
  professionalHeadline: string;
  phone?: string;
  weight: number;
  isTest: boolean;
  ggid: string;
}

export class UserSnowplowContext implements ISnowplowContext {
  public schemaName: string;
  public type: string;
  public subjectId?: number;
  public name: string;
  public email?: string;
  public publicId?: string;
  public hasPicture: boolean;
  public hasBio: boolean;
  public bioCompletion: number;
  public locale?: string;
  public created?: string;
  public professionalHeadline: string;
  public phone?: string;
  public weight: number;
  public isTest: boolean;
  public ggid: string;

  constructor(data: IPerson, type: string = "source", schemaName: string = "UserContext") {
    this.schemaName = schemaName;
    this.type = type;
    this.subjectId = data.subjectId;
    this.name = data.name;
    this.email = data.email;
    this.publicId = data.publicId;
    this.hasPicture = data.picture ? true : false;
    this.hasBio = true;
    this.bioCompletion = data.bioCompletion;
    this.locale = data.locale;
    this.created = data.created;
    this.professionalHeadline = data.professionalHeadline;
    this.phone = data.phone;
    this.weight = data.weight;
    this.isTest = data.isTester || false;
    this.ggid = data.ggId;
  }

  public parseSchema(id: string): IUserContextSchema {
    return {
      schema: id,
      data: this
    };
  }
}
